import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
export const toggleReferralStatus = async ({
  id,
  isOfferActive,
}: {
  id: string;
  isOfferActive: boolean;
}) => {
  const res = await apiManager.patch(`/referral-offer/${id}/toggleOffer`, {
    isOfferActive,
  });
  return res;
};

export const useToggleReferralStatus = () =>
  useMutation({
    mutationFn: async ({ id, isOfferActive }: { id: string; isOfferActive: boolean }) => {
      const res = await apiClient.patch(ENDPOINTS.REFERRAL_OFFERS.TOGGLE_REFERRAL_OFFER(id), { isOfferActive });
      return res.data;
    },
  });